import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { Button, Modal, Dialog } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

const NewAppVersionModal = () => {
  const { t } = useTranslation();
  const reload = () => window.location.reload();

  useEffect(() => {
    /*
      Disable replay after "New App Version" modal has been triggered
      Otherwise if a user leaves their browser window open for hours,
      the Sentry replay plugin can crash (Maximum call stack size exceeded)
     */
    Sentry.getReplay()?.stop();
  }, []);

  return (
    <Modal visible centered>
      <Dialog
        dialog={{
          width: '400px',
          heading: t(translations.newAppVersionTitle),
          content: <>{t(translations.newAppVersionNotice)}</>,
          footer: <Button label={t(translations.newAppVersionReload)} onClick={reload} />,
        }}
      />
    </Modal>
  );
};

export { NewAppVersionModal };
